export default {
  methods: {
    async outExcelTask() {
      try {
        let params = null
        if (this.$refs.hasOwnProperty('params')) {
          params = this.rangHandle(this.$refs.params.searchForm)
          console.log(params)
        }
        const param = this.searchFunParamsHandle(params)

        const countryCode = this.$store.state.base.lang
        param.countryCode = countryCode
        if (typeof this.outExcelBefore === 'function') {
          const state = this.outExcelBefore(param)
          if (!state) {
            return
          }
        }
        this.exportLoading = true
        // 调用导出方法
        const res = await this.COM_HTTP.reqExcel(param)
        this.exportLoading = false
        // 重置自定义导出方法变量this.customOutExcelRegisterApi
        this.customOutExcelRegisterApi = null
        if (res) {
          // 403和502 错误跳过
          // 请求是responseType: 'arraybuffer',错误时返回的是json
          const enc = new TextDecoder('utf-8')
          let errorData = { code: null }
          try {
            errorData = JSON.parse(enc.decode(new Uint8Array(res))) // 转化成json对象
          } catch (error) {
            errorData.code = null
          }
          if (!this.validatenull(errorData.code) && errorData.code !== 1) {
            this.$message.error(errorData.msg)
          } else {
            if (typeof errorData.data === 'boolean' && errorData.data === true) {
              this.$message.success(this.$lang('导出任务已提交，请前往下载中心下载查看'))
            } else {
              if (!!window.ActiveXObject || 'ActiveXObject' in window) {
                // IE
                window.navigator.msSaveOrOpenBlob(res, this.$lang(this.$route.meta.title) + '.xls')
              } else {
                // 火狐谷歌都兼容
                const disposition = res['content-disposition']
                let suffix = '.xls'
                // 如果返回有content-disposition，取返回文件的后缀
                if (disposition) {
                  delete res['content-disposition']
                  suffix = '.' + disposition.split('filename=')[1].split('.')[1]
                }
                const url = window.URL.createObjectURL(new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' }))
                const elink = document.createElement('a')
                elink.style.display = 'none'
                elink.href = url
                console.log(this.$route.meta.title)
                const name = this.excelName || this.$lang(this.$route.meta.title)
                // elink.setAttribute('download', name + suffix)
                elink.setAttribute('download', name + suffix)
                document.body.appendChild(elink)
                elink.click()
                URL.revokeObjectURL(elink.href) // 释放URL 对象
                document.body.removeChild(elink)
                // 重置自定义文件名
                this.excelName = ''
              }
            }
          }
        }
      } catch (error) {
        this.exportLoading = false
        // 重置自定义导出方法变量this.customOutExcelRegisterApi
        this.customOutExcelRegisterApi = null
        console.error('outExcel::error', error)
      }
    }
  }
}
